<div class="toolbar-checkbox form-element {{ config.class}}" id="row-filter">
  <mat-checkbox color="primary" (change)="onChange($event)" ix-auto ix-auto-type="checkbox">
    {{ config.placeholder | translate }}
  </mat-checkbox>
</div>
